import type { ServicesType } from '../../services/types';

export type ServiceConfigType = {
  appAlias: string;
  appAliasWithoutServlet?: string;
  googleMapKey: string;
  staticContentServer: string;
  appStaticContentServer?: string;
  contextPath: string;
  messagingService?: any;
  reAuthUrl?: ServicesType['reAuthUrl'];
};

class ServiceConfig {
  appAlias: ServiceConfigType['appAlias'];
  appAliasWithoutServlet: ServiceConfigType['appAliasWithoutServlet'];
  googleMapKey: ServiceConfigType['googleMapKey'];
  staticContentServer: ServiceConfigType['staticContentServer'];
  appStaticContentServer: string | null;
  contextPath: ServiceConfigType['contextPath'];
  messagingService: ServiceConfigType['messagingService'] | null;
  reAuthUrl: ServicesType['reAuthUrl'];
  constructor(config: ServiceConfigType) {
    this.appAlias = config.appAlias;
    this.appAliasWithoutServlet = config.appAliasWithoutServlet;
    this.googleMapKey = config.googleMapKey;
    this.staticContentServer = config.staticContentServer;
    this.appStaticContentServer = config.appStaticContentServer || null;
    this.contextPath = config.contextPath;
    this.messagingService = config.messagingService || null;
    this.reAuthUrl = config.reAuthUrl || null;
  }
}

export default ServiceConfig;
